// import { Car, Users, BadgeCheck, TrendingUp } from 'lucide-react';

// const stats = [
//   {
//     icon: Car,
//     value: '3,850+',
//     label: 'Total Listings',
//   },
//   {
//     icon: BadgeCheck,
//     value: '450+',
//     label: 'Verified Dealers',
//   },
//   {
//     icon: Users,
//     value: '12,000+',
//     label: 'Registered Users',
//   },
//   {
//     icon: TrendingUp,
//     value: '2,300+',
//     label: 'Vehicles Sold',
//   },
// ];

// export function Statistics() {
//   return (
//     <section className="py-16 bg-[#F5F7FA]">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
//           {stats.map((stat) => {
//             const Icon = stat.icon;
//             return (
//               <div
//                 key={stat.label}
//                 className="relative bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-[#E5E7EB] group overflow-hidden"
//               >
//                 {/* Background Gradient */}
//                 <div className="absolute inset-0 bg-gradient-to-br from-[#1E6DFF]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                
//                 <div className="relative">
//                   {/* Icon */}
//                   <div className="w-14 h-14 bg-[#1E6DFF]/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-[#1E6DFF]/20 transition-all">
//                     <Icon className="w-7 h-7 text-[#1E6DFF]" />
//                   </div>

//                   {/* Value */}
//                   <div className="text-4xl text-[#2D323A] mb-2">
//                     {stat.value}
//                   </div>

//                   {/* Label */}
//                   <div className="text-[#717182]">
//                     {stat.label}
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </section>
//   );
// }
// src/components/Statistics.jsx
import { Car, Users, BadgeCheck, TrendingUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { getPublicStatistics, PublicStatistics } from '../../services/cms.service';
import { useCms } from '../hooks/useCms';

export function Statistics() {
  const { t, i18n } = useTranslation('home');
  const { get } = useCms('home');
  const [counts, setCounts] = useState<PublicStatistics | null>(null);

  useEffect(() => {
    let active = true;
    getPublicStatistics()
      .then((data) => active && setCounts(data))
      .catch((error) => console.error('Unable to load public statistics', error));
    return () => { active = false; };
  }, []);

  const format = (value?: number) =>
    value === undefined ? '—' : new Intl.NumberFormat(i18n.language || 'en').format(value);
  const stats = [
    { icon: Car, value: format(counts?.totalListings), label: get('statistics.stat1', t('statistics.listings')) },
    { icon: BadgeCheck, value: format(counts?.verifiedDealers), label: get('statistics.stat2', t('statistics.dealers')) },
    { icon: Users, value: format(counts?.registeredUsers), label: get('statistics.stat3', t('statistics.users')) },
    { icon: TrendingUp, value: format(counts?.activeListings), label: get('statistics.stat4', 'Active Listings') },
  ];

  return (
    <section className="py-16 bg-[#F5F7FA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat) => {
            const Icon = stat.icon;
            return (
              <div
                key={stat.label}
                className="relative bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-[#E5E7EB] group overflow-hidden"
              >
                {/* Background Gradient */}
                <div className="absolute inset-0 bg-gradient-to-br from-[#1E6DFF]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                
                <div className="relative">
                  {/* Icon */}
                  <div className="w-14 h-14 bg-[#1E6DFF]/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-[#1E6DFF]/20 transition-all">
                    <Icon className="w-7 h-7 text-[#1E6DFF]" />
                  </div>

                  {/* Value */}
                  <div className="text-4xl text-[#2D323A] mb-2">
                    {stat.value}
                  </div>

                  {/* Label */}
                  <div className="text-[#717182]">
                    {stat.label}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}